import { render, staticRenderFns } from "./NitrateDetail.vue?vue&type=template&id=3ebc16a7&scoped=true&"
import script from "./NitrateDetail.vue?vue&type=script&lang=js&"
export * from "./NitrateDetail.vue?vue&type=script&lang=js&"
import style0 from "./NitrateDetail.vue?vue&type=style&index=0&id=3ebc16a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc16a7",
  null
  
)

export default component.exports